import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import AOS from 'aos'
import 'aos/dist/aos.css'
// Import Quill CSS
import 'quill/dist/quill.snow.css'
// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// Import gestion authentification
import { setupHttpErrorHandler } from './utils/authCheck'

// Import des icônes que tu utilises
import { 
  faEye, 
  faReply, 
  faHouse, 
  faBlog, 
  faPen, 
  faQuestion, 
  faRightFromBracket ,
  faAngleLeft, faAngleRight
} from '@fortawesome/free-solid-svg-icons'

// Ajout des icônes à la librairie
library.add(faEye, faReply, faHouse, faBlog, faPen, faQuestion, faRightFromBracket, faAngleLeft, faAngleRight)

// Import vue3-toastify
import Vue3Toastify, { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

AOS.init()

const app = createApp(App)

// Enregistrer FontAwesome comme composant global
app.component('font-awesome-icon', FontAwesomeIcon)

// Configurer vue3-toastify avec options par défaut
app.use(Vue3Toastify, {
  autoClose: 5000,
  position: 'top-right'
})

app.use(store)
app.use(router)

// Installer l'intercepteur HTTP pour gérer automatiquement les erreurs 401/403
setupHttpErrorHandler('userToken', router)
console.log('[App] ✅ Intercepteur HTTP installé pour Agence')

app.mount('#app')

// Exporter `toast` pour l'utiliser dans tes composants sans réimporter
export { toast }
